'use client';
import Link from 'next/link';
import { trackStatistic } from '@/lib/utils/statisticTracker';
import SidebarSection from './SidebarSection';
import { generateLink } from './sidebar.utils';
import { useSidebarFilter } from './useSidebarFilter';

export const featuresOptions = [
  {
    id: 'highSalary',
    name: 'Өндөр цалинтай ажлын байр',
  },
  {
    id: '45plus',
    name: '45-аас дээш насны иргэд ажиллах боломжтой ажлын байр',
  },
  {
    id: 'disability',
    name: 'Хөгжлийн бэрхшээлтэй иргэн ажиллах боломжтой ажлын байр',
  },
  { id: 'leader', name: 'Удирдах албан тушаалын ажлын байр' },
  { id: 'isRemote', name: 'Зайнаас ажиллах боломжтой ажлын байр' },
  { id: 'onDarkhan', name: 'Дархан хот дахь ажлын байр' },
  { id: 'onErdenet', name: 'Эрдэнэт хот дахь ажлын байр' },
  { id: 'student', name: 'Дадлагын ажлын байр /Оюутан/' },
  { id: 'freelancer', name: 'Түр ажлын байр /Freelancer/' },
];

const FeaturedCategoryComponent = () => {
  const { searchParams } = useSidebarFilter();

  return (
    <SidebarSection title="Онцлох">
      <ul className="flex flex-col gap-4">
        {featuresOptions.map((option, optionIndex) => (
          <li key={optionIndex} className="cursor-pointer">
            <Link
              href={generateLink('features', option.id, searchParams)}
              passHref
              className="flex gap-2 group"
              onClick={() => trackStatistic(`quick_filter_${option.id}`)}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-primary/30 mt-2 flex-shrink-0 group-hover:bg-primary"></span>
              <span className="leading-5">{option.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </SidebarSection>
  );
};

export default FeaturedCategoryComponent;
